import { httpDelete, httpGet, httpPost } from '@/lib/http';
import { createAsyncThunk } from '@reduxjs/toolkit';

export const fetchAllExams = createAsyncThunk(
  'exam/fetchAll',
  async (allExams: boolean | undefined = false, { rejectWithValue, dispatch }) => {
    try {
      const res = await httpGet({ url: '/exams', dispatch });

      let exams = res?.data || [];

      if (allExams) {
        exams = await Promise.all(exams.map(async (exam: any) => {
          const questionsRes = await httpGet({ url: `/exams/${exam?.id}/questions`, dispatch });
          return {
            ...exam,
            questions: questionsRes?.data || [],
          };
        }));
      }

      return exams || [];
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const saveExam = createAsyncThunk(
  'exam/save',
  async (exam: any, { rejectWithValue, dispatch }) => {
    try {
      const res = await httpPost({ url: '/exams', payload: exam, dispatch });
      if (res?.status !== 200) {
        return rejectWithValue('Failed to save exam');
      }
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const removeExamById = createAsyncThunk(
  'exam/removeById',
  async (id: string, { rejectWithValue, dispatch }) => {
    try {
      const res = await httpDelete({ url: `/exams/${id}`, dispatch });
      if (res?.status !== 200) {
        return rejectWithValue('Failed to remove exam by id');
      }
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

// export const fetchExamQuestionsById = createAsyncThunk(
//   'exam/fetchById',
//   async (id, { rejectWithValue, dispatch }) => {
//     try {
//       const res = await httpGet({ url: `/exams/${id}/questions`, dispatch });
//       if (!res?.data) {
//         return rejectWithValue('Failed to fetch exam by id');
//       }
//       return res?.data || {};
//     } catch (error: any) {
//       return rejectWithValue(error.message);
//     }
//   }
// );
